package com.kinoshazam.uiKit.components.genreItem

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import com.kinoshazam.uiKit.components.image.ImageUiKitState
import com.kinoshazam.uiKit.components.image.UiKitImage
import com.kinoshazam.uiKit.components.textLabel.TextLabel
import com.kinoshazam.uiKit.components.textLabel.TextLabelState
import com.kinoshazam.uiKit.theme.UiKitTheme

@Composable
fun CompactGenreItem(
    state: GenreItemState,
    modifier: Modifier = Modifier,
    onAction: () -> Unit = {},
) {
    var modifier = modifier
        .size(130.dp, 90.dp)
        .clip(RoundedCornerShape(2.dp))
        .background(UiKitTheme.colors.color_4)
        .clickable(onClick = {
            onAction()
        })

    Column(
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally,
        modifier = modifier,
    ) {
        UiKitImage(
            state = ImageUiKitState(
                url = null,
                placeholder = state.icon,
                contentScale = ContentScale.Crop,
            ),
            modifier = Modifier.size(40.dp, 40.dp)
        )
        Spacer(modifier = Modifier.height(12.dp))
        TextLabel(
            state = TextLabelState(
                text = state.title,
                color = UiKitTheme.colors.color_2
            )
        )
    }
}